import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  dataAdded,
  dataFetched,
  dataRemoved,
  makesSubscriptions,
} from 'data/graphql'

import {
  channelActivityAknowledged,
  noteActivityAknowledged,
  threadActivitiesAknowledged,
} from 'remote/activityRegistry'

import { setSubscriptionStatus } from 'data/ui/actions'

export const providesActivityRegistrySubscriptions = compose(
  connect(
    null,
    {
      dataAdded,
      dataFetched,
      dataRemoved,
      setSubscriptionStatus,
    }
  ),
  makesSubscriptions({
    query: channelActivityAknowledged,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.channelActivityAknowledged, meta)
      setSubscriptionStatus({ type: 'channelActivityAknowledged' })
    },
  }),
  makesSubscriptions({
    query: noteActivityAknowledged,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched, setSubscriptionStatus }) => ({
      result,
      meta,
    }) => {
      dataFetched(result.data.noteActivityAknowledged, meta)
      setSubscriptionStatus({ type: 'noteActivityAknowledged' })
    },
  }),
  makesSubscriptions({
    query: threadActivitiesAknowledged,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched, setSubscriptionStatus }) => ({
      result,
      meta,
    }) => {
      dataFetched(result.data.threadActivitiesAknowledged, meta)
      setSubscriptionStatus({ type: 'threadActivitiesAknowledged' })
    },
  })
)
